import { JsonServiceClient } from "@servicestack/client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as DTOS from "../FeralScan.dtos";

export const serviceApi = {
    getUserGroup: (groupId: number) => {
        var client = new JsonServiceClient("");
        var request = new DTOS.GetUserGroup();

        request.groupId = groupId;

        const promise = client.get(request);
        return Observable.from(promise);
    }
};
